<template>
  <nav class="dashboard_menu">
    <div class="nav nav-tabs" role="tablist">
      <router-link
          :to="{ name: 'dashboardSiteManagerInfo'}"
          :class="{ active: $route.name === 'dashboardSiteManagerInfo' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.info') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardSiteManagerCoaches' }"
          :class="{ active: $route.name === 'dashboardSiteManagerCoaches' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.coaches') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardSiteManagerPotentialUnits' }"
          :class="{ active: $route.name === 'dashboardSiteManagerPotentialUnits' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.preview_units_locations') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardSiteManagerUnitsDoneByLocation' }"
          :class="{ active: $route.name === 'dashboardSiteManagerUnitsDoneByLocation' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.filterLocation') }}
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { RouterLink } from 'vue-router';
</script>


<style scoped>

</style>